import urlencode  from './urlencode';
import { appkey, secret }  from '../config';
import md5 from 'js-md5'

var sign = {
    // 安全的参数编码方法，处理包含特殊字符的URL值
    safeEncodeParams(params) {
        var encodedPairs = [];
        for (var key in params) {
            if (params.hasOwnProperty(key) && params[key] !== '' && params[key] !== null && params[key] !== undefined) {
                // 对键值分别进行URL编码，确保URL中的&、=等特殊字符不会干扰参数解析
                var encodedKey = encodeURIComponent(key);
                var encodedValue = encodeURIComponent(params[key]);
                encodedPairs.push(encodedKey + '=' + encodedValue);
            }
        }
        return encodedPairs.join('&').replace(/\+/g, '%20');
    },

    getSign(params) {
        var timestamp = parseInt(+new Date()/1000);
        var params_format_str = "appkey="+appkey+"&timestamp="+timestamp;
        if(JSON.stringify(params) != '{}') {
            // 使用安全的参数编码方法，替代原来的encodeSearchParams
            params_format_str += "&" + this.safeEncodeParams(params);
        }

        var arr1 = [];
        var params_format_arr = params_format_str.split("&");
        for (var i in params_format_arr) {
            // 使用indexOf来找到第一个=的位置，避免值中包含=时的问题
            var equalIndex = params_format_arr[i].indexOf("=");
            if(equalIndex > 0) {
                var key = params_format_arr[i].substring(0, equalIndex);
                var value = params_format_arr[i].substring(equalIndex + 1);
                if(key != "" && value != "" && key != 'urlsign') {
                    arr1.push(key + "=" + value);
                }
            }
        }
        var arr = [];
        for (var i in arr1) {
            // 同样使用indexOf来处理可能包含=的值
            var equalIndex = arr1[i].indexOf("=");
            if(equalIndex > 0) {
                var key = arr1[i].substring(0, equalIndex);
                var value = arr1[i].substring(equalIndex + 1);
                //过滤重复的key，与golang解析保持一致
                arr.push(urlencode(decodeURIComponent(key))+'='+urlencode(decodeURIComponent(value)));
            }
        }

        var urlSign = this.paramsStrSort(arr.join("&"));
        return urlSign;
    },
    
    getSignParam(params) {
        var timestamp = parseInt(+new Date()/1000);
        var urlSign = this.getSign(params);
        var paramsSignd = JSON.parse(JSON.stringify({appkey:appkey, timestamp:timestamp, urlsign:urlSign}, params));
        return paramsSignd;
    },
    
    paramsStrSort: function (paramsStr) {
        var urlStr = paramsStr.split("&").sort().join("&")+"&secret="+md5(secret).toUpperCase();
        var res = md5(urlStr).toUpperCase();
        return res;
    },
    
    urlRawParam: function (params) {
        var arr = [];
        for (var i in params) {
            if(params[i] != "" && i != "") {
                arr.push(((i) + "=" + (params[i])));
            }
        }
        return arr.sort().join("&");
    },
    
    buildSignParam: function (param) {
        var timestamp = parseInt(+new Date()/1000);
        var param = JSON.parse(JSON.stringify({appkey:appkey, timestamp:timestamp}, param || {}));
        var signparam = this.getSignParam(param);
        var urlRawParam = this.urlRawParam(signparam);
        return urlRawParam;
    }
}

export default sign